const mobileMenuDataLahalle = [
  {
    id: 1,
    label: "Réserver un échange",
    icon : "/images/icons/IconeCalendrierHorloge.svg",
    iconActive : "/images/icons/IconeCalendrierHorloge.svg",
    routePath: "/",
    reserved: true,
    infos: false,
  },
  {
    id: 2,
    label: "FAQ",
    icon : "/images/icons/IconeFAQ.svg",
    iconActive : "/images/icons/IconeFAQ.svg",
    routePath: "/",
    reserved: false,
    infos: false,
    faq: true,
  },
  {
    id: 3,
    label: "Vos ressources handicap",
    icon : "/images/icons/IconeRessources.svg",
    iconActive : "/images/icons/IconeRessources.svg",
    routePath: "#resources",
  },

  {
    id: 4,
    label: "Comment ça marche ?",
    icon : "/images/icons/IconeInformation.svg",
    iconActive : "/images/icons/IconeInformation.svg",
    routePath: "/",
    reserved: false,
    infos: true,
  },
  /*{
    id: 5,
    label: "Nos webinaires",
    icon : "/images/icons/IconePlay.svg",
    iconActive : "/images/icons/IconePlay.svg",
    routePath: "https://www.talents-handicap.com/lahalle/webinaires",
    reserved: false,
    infos: false,
    class: 'webinaire'
  },*/
];

export default mobileMenuDataLahalle;
